export enum AuthorizationServiceTypes {
    LICENSES = "slick"
}

export enum AuthorizationRouteTypes {
    GET_SERVERS = "server:query",
}

export enum AuthorizationPermissionTypes {}
